import { createUseStyles } from 'react-jss'

import { card } from '../../styles/common'

export const fileNameMargin = 10

const useStyles = createUseStyles(theme => ({
  clickablePreview: {
    display: 'flex',
    flexGrow: 1,
    cursor: 'pointer'
  },
  fileDetails: {
    extend: card,
    borderColor: theme.brandPrimary,
    filter: 'unset',
    padding: '8px 12px',
    marginTop: 8,
    '&:first-of-type': {
      marginTop: 16
    }
  },
  progressBar: {
    marginTop: 10
  },
  deleteBtn: {
    width: 24,
    height: 24,
    marginLeft: fileNameMargin
  },
  uploadedContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative'
  }
}))

export default useStyles
